import { http } from './http';

export function getPublicGenres() {
  return http.get('/api/v1/genres').then((r) => r.data);
}
